import { render, staticRenderFns } from "./BrandQueryHistoryItemTile.vue?vue&type=template&id=0875197f&scoped=true&"
import script from "./BrandQueryHistoryItemTile.vue?vue&type=script&lang=ts&"
export * from "./BrandQueryHistoryItemTile.vue?vue&type=script&lang=ts&"
import style0 from "./BrandQueryHistoryItemTile.vue?vue&type=style&index=0&id=0875197f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875197f",
  null
  
)

export default component.exports